import PropTypes from 'prop-types';
import React from 'react';
import { Spinner, DropdownButton } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import DescargarXML from 'akasia-components/cliente/orden/seccion-header/DescargarXML';
import DescargarPDF from 'akasia-components/cliente/orden/seccion-header/DescargarPDF';

const HeaderFactura = ({
    isActive,
    ordenesVinculadas,
    vUUIDFactura,
    dFechaEmision,
    vRfcEmisor,
    idFactura}) => {
    const primeraOrden = ordenesVinculadas && ordenesVinculadas.length > 0 ? ordenesVinculadas[0] : null;

    return (
        <div className="mb-1">
            <div className={`d-flex justify-content-between align-items-center ${isActive === false ? 'border border-danger rounded px-3 py-2 text-danger bg-light shadow-sm' : ''}`}>
                {primeraOrden ? (
                    <h5 className="m-0" style={{ color: 'inherit' }}>
                        {isActive === false && <i className="bi bi-exclamation-triangle-fill me-2"></i>}
                        Factura Emitida | 🛒 <Link to={"/ordenes/detalle/" + primeraOrden.idOrden} style={{ color: isActive === false ? 'inherit' : undefined }}>ORDEN #{primeraOrden.idOrden}</Link> → {primeraOrden.dTotal} {primeraOrden.vMoneda} | {primeraOrden.bIsPagada ? 'Pagada' : 'Pendiente'}
                    </h5>
                ) : (
                    <h5 className="m-0" style={{ color: 'inherit' }}>
                        {isActive === false && <i className="bi bi-exclamation-triangle-fill me-2"></i>}
                        Factura Emitida
                    </h5>
                )}
                <div className="d-flex align-items-center">
                    {isActive === undefined || isActive === null ? (
                        <span className="me-2">
                            <Spinner animation="border" size="sm" variant="secondary" />
                        </span>
                    ) : (
                        <>
                            <span
                                className="me-2"
                                style={{
                                    width: '10px',
                                    height: '10px',
                                    borderRadius: '50%',
                                    backgroundColor: isActive ? 'green' : 'red',
                                    display: 'inline-block'
                                }}
                            ></span>
                            {isActive ? (
                                <DropdownButton
                                    variant="success"
                                    title="Factura Activa"
                                    size="sm"
                                >
                                    <DescargarPDF
                                        idFactura={idFactura}
                                        vUUIDFactura={vUUIDFactura}
                                    />
                                    <DescargarXML
                                        vUUIDFactura={vUUIDFactura}
                                        dFechaEmision={dFechaEmision}
                                        vRfcEmisor={vRfcEmisor}
                                    />
                                </DropdownButton>
                            ) : (
                                <span className="text-danger">
                                    Factura Cancelada
                                </span>
                            )}
                        </>
                    )}
                </div>
            </div>
            <hr></hr>
        </div>
    );
};

HeaderFactura.propTypes = {
    isActive: PropTypes.bool,
    ordenesVinculadas: PropTypes.array,
    vUUIDFactura: PropTypes.string,
    dFechaEmision: PropTypes.string,
    vRfcEmisor: PropTypes.string,
    idFactura: PropTypes.number,
};

export default HeaderFactura;